<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="9">
              <h3>Regimento Interno</h3>
            </b-col>
            <b-col md="3">
              <b-button v-if="can('regimento.store')" @click="navigate('/regimento/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                  <span>Novo Regimento</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Nome</th>
                      <th scope="col">Status</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="regimentos.data !== undefined">
                    <tr class="action" v-for="regimento in regimentos.data" :key="regimento.id">
                      <td>{{regimento.titulo}}</td>
                      <td>
                        <span v-if="regimento.situacao === 'C'" class="badge badge-primary">Salvo</span>
                        <span v-if="regimento.situacao === 'E'" class="badge badge-success">Enviado</span>
                        <span v-if="regimento.situacao === 'S'" class="badge badge-danger">Suspenso</span>
                      </td>
                      <td style="width: 15%">
                          <a v-if="can('regimento.update') && (regimento.situacao === 'C' || regimento.situacao === 'S')" class="btn btn-sm btn-secondary action" title="Editar" @click="editarRegimento(regimento.id)">
                            <i class="fa fa-pencil-square-o"></i>
                          </a>

                          <a v-if="can('regimento.show')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarRegimento(regimento.id)">
                            <i class="fa fa-search"></i>
                          </a>

                          <a v-if="can('regimento.publicar')  && (regimento.situacao === 'C' || regimento.situacao === 'S')" class="btn btn-sm btn-secondary action" title="Enviar Regimento" @click="enviarRegimento(regimento.id)">
                            <i class="fa fa-envelope"></i>
                          </a>

                          <a v-if="can('regimento.suspender') && regimento.situacao === 'E'" class="btn btn-sm btn-secondary action" title="Suspender" @click="suspenderRegimento(regimento.id)">
                            <i class="fa fa-times"></i>
                          </a>

                          <a class="btn btn-sm btn-secondary action" title="Exportar" @click="exportarRegimento(regimento.id)">
                            <i class="fa fa-file"></i>
                          </a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="3">Regimento não cadastado</td>
                    </tr>
                  </tbody>
                </table>
                <pagination v-show="regimentos.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.can('regimento.index')) {
      this.$router.push('/')
    }
  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'regimento',
      filtros: {}
    }
  },
  computed: {
    regimentos () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState () {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    editarRegimento (id) {
      this.$router.push('/regimento/editar/' + id)
    },
    visualizarRegimento (id) {
      this.$router.push('/regimento/visualizar/' + id)
    },
    enviarRegimento (id) {
      this.$bvModal.msgBoxConfirm('Deseja enviar o Regimento Interno para os Delegados? Ao enviar, estará permitindo aos delegados a visualização e inserção de sugestões no regimento interno.', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/regimento/' + id + '/enviado').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderRegimento (id) {
      this.$bvModal.msgBoxConfirm('Deseja suspender a visualização do regimento interno para os perfis de delegados? Ao suspender, estará desabilitando a visualização e inserção dos delegados no regimento interno.', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/regimento/' + id + '/suspenso').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    exportarRegimento (regimento) {
      window.location.href = process.env.ROOT_API1 + 'api/regimento/' + regimento + '/documento'
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/regimento/Regimento.vue